import React, { useState } from 'react';
import { useSelector } from "react-redux";
import arBtn from '../../assets/icons/viewAR.svg';
import { sendAnalyticsData } from "../../utility/levarAnalytics";
const BUCKET_URL = process.env.REACT_APP_BUCKET_URL_AR;

const SceneViewerBtn = () => {
  const [loading, setLoading] = useState(false);

  const { session_id, hash, variant, referrer, product_id } = useSelector(state => ({
    session_id: state.session_id,
    hash: state.hash,
    variant: state.variant,
    referrer: state.referrer,
    product_id: state.product_id,
  }));

  const handleLaunchAR = async (e) => {
    e.preventDefault()
    setLoading(true);
    if(session_id) await sendAnalyticsData({ session_id, hash, variant, event_type: 'view_ar_launch', referrer, product_id });

    const url = `${BUCKET_URL}${hash}.glb`;
    const sceneViewerUrl = handleSceneViewerUrl(url);

    const anchor = document.createElement('a');
    anchor.appendChild(document.createElement('img'));
    anchor.setAttribute('href', sceneViewerUrl);

    setTimeout(() => {
      anchor.click();
      setLoading(false);
    }, 1000);
  };

  const handleSceneViewerUrl = (glbURL) => {
    let sceneURL = "#Intent;scheme=https;package=com.google.ar.core;action=android.intent.action.VIEW;S.browser_fallback_url=https://developers.google.com/ar;end;"
    let combinedUrl = `intent://arvr.google.com/scene-viewer/1.0?file=${glbURL}&mode=ar_only&resizable=false${sceneURL}`;

    return combinedUrl
  };

  return (
    <div className="LevarUI-IOS">
      <button onClick={(e) => handleLaunchAR(e)}>
        {
          !loading ? (
            <img src={arBtn} alt="Launch in AR"/>
          ) : ( <div className="Loader-IOS"></div> )
        }
      </button>
    </div>
  );
};

export default SceneViewerBtn;


// class SceneViewerBtn extends Component {
//
//   componentDidMount() {
//     // let sceneViewer = document.getElementById('sceneViewer-btn');
//     // sceneViewer.click()
//   }
//
//   handleLaunchAR = (event) => {
//     event.preventDefault();
//     this.props.setLoading(true)
//   }
//
//   handleSceneViewerUrl = (glbURL) => {
//     let sceneURL = "#Intent;scheme=https;package=com.google.ar.core;action=android.intent.action.VIEW;S.browser_fallback_url=https://developers.google.com/ar;end;"
//     let combinedUrl = `intent://arvr.google.com/scene-viewer/1.0?file=${glbURL}&mode=ar_only${sceneURL}`;
//
//     return combinedUrl
//   }
//
//   render() {
//
//     const { hash } = this.props;
//     const url = `${BUCKET_URL}${hash}.glb`;

//     const sceneViewerUrl = this.handleSceneViewerUrl(url);
//
//     return (
//       <div className="LevarUI-AR SceneViewer">
//         <a href={sceneViewerUrl} id="sceneViewer-btn">
//           <img src={arBtn} alt="Launch in AR"/>
//         </a>
//       </div>
//     )
//   }
// }
//
// export const mapStateToProps = state => ({
//   loading: state.loading,
//   hash: state.hash,
// });
//
// export const mapDispatchToProps = dispatch => ({
//   setLoading: data => dispatch(actions.setLoading(data)),
// });
//
// export default connect(mapStateToProps, mapDispatchToProps)(SceneViewerBtn);
